import React from "react";
import Marquee from "react-fast-marquee";

export default function Gallery() {
  return (
    <>
      <div className="tp-gallery-area fix p-relative">
        <div className="tp-gallery-shape-1">
          <img
            className="img-2"
            src="assets/img/one/gal-shape-dark-1.png"
            alt="img"
          />
        </div>
        <div className="tp-gallery-shape-2">
          <img
            className="img-2"
            src="assets/img/one/gal-shape-dark-2.png"
            alt="img"
          />
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-gallery-slider-wrap">
                <div className="swiper-container tp-gallery-slider-active">
                  <div className="swiper-wrapper tp-gallery-titming">
                    <Marquee>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/01.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/02.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/03.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/04.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/05.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/06.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/01.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/02.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/03.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/04.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/05.jpg" alt="img" />
                        </div>
                      </div>
                      <div className="swiper-slide mx-3">
                        <div className="tp-gallery-item">
                          <img src="assets/img/one/06.jpg" alt="img" />
                        </div>
                      </div>
                    </Marquee>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
